// extracted by mini-css-extract-plugin
export default {"calendar-cell-scroll":"calendarwrapper_calendar-cell-scroll__-ZeI9"};